import React from "react";
import { useNavigate } from "react-router-dom";
//MUI
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import BooksTable from "./componentes/BooksTable";
import BooksWorkflowContainer from "./workflows/BooksWorkflowContainer";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

export function Books() {
  const navigate = useNavigate();
  return (
    <>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "1.0rem",
              }}
            >
              <Typography variant="h5">Bokföring</Typography>
              <Button
                onClick={() => navigate("create")}
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
              >
                SKAPA NY
              </Button>
            </Box>

            <BooksTable />
            <BooksWorkflowContainer />
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
